'use strict'

/**
 * Типы actions, доступные для вызова в хранилище
 */

export const APP = {
    id: {
        set: 'app/id/set'
    },
    menuItems: {
        set: 'app/menu-items/set'
    },
    queue: {
        set: 'app/queue/set'
    },
    phone: {
        set: 'app/phone/set'
    },
    client: {
        set: 'app/client/set'
    },
    servicing: {
        set: 'app/servicing/set'
    },
    registration: {
        set: 'app/registration/set'
    },
    apiKey: {
        set: 'app/apiKey/set'
    },
    referer: {
        set: 'app/referrer/set'
    }
}

export const GUI = {
    loadingId: {
        set: 'gui/loadingId/set',
        reset: 'gui/loadingId/reset'
    },
    loading: {
        set: 'gui/loading/set'
    },
    error: {
        set: 'gui/error/set'
    },
    warning: {
      set: 'gui/warning/set',
      get: 'gui/warning/get'
    },
    layout: {
        set: 'gui/layout/set'
    },
    colorSchema: {
        set: 'gui/colorSchema/set'
    },
    tryInit: {
        set: 'gui/tryInit/set'
    }
}
